import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TokenGeneratorRoutingModule } from './token-generator-routing.module';
import { TokenGeneratorComponent } from './token-generator.component';
import { CreateTokenComponent } from './components/create-token/create-token.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { MyTokensComponent } from './components/my-tokens/my-tokens.component';


@NgModule({
  declarations: [
    TokenGeneratorComponent,
    CreateTokenComponent,
    MyTokensComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TokenGeneratorRoutingModule,
    NgxMaskModule.forChild()
  ]
})
export class TokenGeneratorModule { }
